var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.plain)?_c('strong',[_vm._v("AI Reply:")]):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.typedText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }